import { css } from 'emotion'
import { PRIMARY_COLOR } from '../../constants/styleConstants'

export const textPrimaryColorStyles = css`
  color: ${PRIMARY_COLOR};
`
